import { render } from "./SearchContacts.vue?vue&type=template&id=606e8c21&scoped=true"
import script from "./SearchContacts.vue?vue&type=script&lang=js"
export * from "./SearchContacts.vue?vue&type=script&lang=js"

import "./SearchContacts.vue?vue&type=style&index=0&id=606e8c21&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-606e8c21"]])

export default __exports__